import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Keyboard } from 'lucide-react';

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="mb-6">
        <span className="text-8xl font-bold text-accent">404</span>
      </div>
      <h1 className="text-2xl font-bold text-text mb-2">Page Not Found</h1>
      <p className="text-text-secondary mb-8 max-w-md">
        Looks like you've wandered off the keyboard. The page you're looking for doesn't exist.
      </p>
      <div className="flex gap-4">
        <Link
          to="/"
          className="flex items-center gap-2 px-6 py-3 bg-accent text-background font-semibold rounded-lg hover:bg-accent/90 transition-colors"
        >
          <Home size={18} />
          Go Home
        </Link>
        <Link
          to="/typing"
          className="flex items-center gap-2 px-6 py-3 bg-primary border border-border text-text font-semibold rounded-lg hover:bg-primary/80 transition-colors"
        >
          <Keyboard size={18} />
          Start Typing
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
